module.exports = __webpack_public_path__ + "static/media/29ADMSPC15.0c3476d4.jpg";